import { render, staticRenderFns } from "./ReleaseNoteDirectCopyDialog.vue?vue&type=template&id=f28e1f2e"
import script from "./ReleaseNoteDirectCopyDialog.vue?vue&type=script&lang=js"
export * from "./ReleaseNoteDirectCopyDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports